
document.addEventListener("DOMContentLoaded", async () => {
  const section = document.querySelector("[data-complete-look]");
  if (!section) return;

  const rail = section.querySelector(".bz-cl-rail");
  if (!rail) return;

  const currentHandle = (section.dataset.handle || "").toLowerCase();
  const currentMetal = (section.dataset.metal || "").toLowerCase();
  const currentColor = (section.dataset.color || "").toLowerCase();
  const currentType = (section.dataset.type || "").toLowerCase();

  // Tuning knobs
  const MAX_PAGES = 3;              // 3 * 250 = 750 products scanned
  const PRODUCTS_PER_PAGE = 250;
  const MIN_SCORE_TO_SHOW = 4;      // forces “curated” results
  const TARGET_COUNT = 8;           // 6–10 (we’ll aim for 8)

  // Optional: show nothing if key attributes missing (prevents randomness)
  // Metal is optional. Color and type are required.
  if (!currentColor || !currentType) {
    console.warn("[CompleteLook] Missing required data:", {
      currentMetal,
      currentColor,
      currentType
    });
    return;
  }

  async function fetchPage(page) {
    const url = `/collections/all/products.json?limit=${PRODUCTS_PER_PAGE}&page=${page}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;
    return res.json();
  }

  async function fetchProducts() {
    const all = [];

    for (let page = 1; page <= MAX_PAGES; page++) {
      try {
        const data = await fetchPage(page);
        const products = data?.products || [];

        if (products.length === 0) break;

        all.push(...products);

        // If we got less than limit, we've hit the end
        if (products.length < PRODUCTS_PER_PAGE) break;
      } catch (err) {
        console.error("[CompleteLook] Product fetch failed on page", page, err);
        break;
      }
    }

    return all;
  }

  function scoreProduct(product) {
    const handle = (product.handle || "").toLowerCase();
    if (!handle || handle === currentHandle) return -999;

    const productType = (product.product_type || "").toLowerCase();
    if (productType && productType === currentType) return -999;

    const tags = (product.tags || []).map(t => String(t).toLowerCase());

    // RULE 1 — METAL MATCHING
    // If the current product has a metal, matching metal is mandatory.
    // If metal is empty, color becomes the primary matching attribute.
    // This engine can only "see" tags from products.json, not metafields.
    if (currentMetal && !tags.includes(currentMetal)) return -999;

    // RULE 2 (color same OR neutral OR mixed)
    // Mixed Colors on the current product allows any color.
    const isMixedColors =
      currentColor.replace(/[\s_-]/g, "") === "mixedcolors";

    const colorOK =
      isMixedColors ||
      tags.includes(currentColor) ||
      tags.includes("neutral") ||
      tags.includes("mixed");

    if (!colorOK) return -999;

    // Scoring / ranking (deterministic ordering)
    let score = 0;

    // Metal matched when present.
    // Without metal, color matching is the primary requirement.
    score += currentMetal ? 3 : MIN_SCORE_TO_SHOW;

    if (isMixedColors || tags.includes(currentColor)) score += 3;
    if (tags.includes("neutral")) score += 2;
    if (tags.includes("mixed")) score += 1;

    // Small boost for having an image (prevents blanks)
    if (product.images?.[0]?.src) score += 0.2;

    return score;
  }

  function render(products) {

  rail.innerHTML = `
    <div class="resource-list resource-list--carousel">
      <div class="resource-list__carousel">
        ${products.map(p => {

          const img = p.images?.[0]?.src || "";
          const title = p.title || "";
          const url = `/products/${p.handle}`;

          return `
            <div class="resource-list__item">
              <a href="${url}" class="card product-card-link">

                <div class="card__media">
                  <img src="${img}" alt="${title}" loading="lazy">
                </div>

                <div class="card__content">
                  <p class="card__heading">${title}</p>
                </div>

              </a>
            </div>
          `;

        }).join("")}
      </div>
    </div>
  `;
}

  try {
    const products = await fetchProducts();

    console.log("[CompleteLook] scanned products:", products.length);

    const scored = products
      .map(p => ({ p, score: scoreProduct(p) }))
      .filter(x => x.score >= MIN_SCORE_TO_SHOW)
      .sort((a, b) => b.score - a.score)
      .slice(0, TARGET_COUNT)
      .map(x => x.p);

    console.log("[CompleteLook] selected:", scored.map(p => p.handle));

    if (scored.length === 0) {
      console.warn("[CompleteLook] No matches after filtering. Check tags:", {
        currentMetal,
        currentColor,
        currentType
      });
      return;
    }

    render(scored);
  } catch (err) {
    console.error("[CompleteLook] engine failed:", err);
  }
});
